/* Marks the document as scrolled so the header can go white the instant scrolling starts.

   Madrid already has an overlay system (assets/header.js) that swaps the header off its
   transparent scheme — but only once the header leaves the section it overlays, so on the
   homepage the bar stayed transparent for the whole hero. The reference Serena gave
   (minkpink.com) turns it white as soon as you move.

   Deliberately does not touch any of Madrid's classes: it only adds `stl-scrolled` to
   <html>, and the white treatment lives in custom.css. At scrollY 0 the class is absent and
   Madrid's transparent-over-hero rendering is left exactly as it was.

   Uses a passive scroll listener coalesced with a timer rather than requestAnimationFrame —
   rAF is suspended while a tab is hidden, which would leave the header stuck in whichever
   state it was in when the tab lost focus. */

(function () {
  'use strict';

  var root = document.documentElement;
  var CLASS = 'stl-scrolled';
  var pending = false;

  function apply() {
    var scrolled = (window.pageYOffset || root.scrollTop || 0) > 0;
    root.classList.toggle(CLASS, scrolled);
  }

  window.addEventListener('scroll', function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      apply();
    }, 0);
  }, { passive: true });

  /* Covers a reload part-way down the page, and a browser restoring scroll position. */
  apply();
})();
